import styled from 'styled-components';

export const MeasuresContainer = styled.div`
  display: flex;
  & > span {
    margin-right: 0.187rem;
  }
`;
